import { Symbology } from '@scandit/web-datacapture-barcode'
import { ScannerMode } from './InitialOptionsStore'

export type ExtensionName = 'five_digit_add_on' | 'two_digit_add_on'
export type Extension = {
  type: 'extension'
  name: ExtensionName
  humanReadable: string
}

const TwoDigitAddon: Extension = {
  name: 'two_digit_add_on',
  type: 'extension',
  humanReadable: '2 digit Addon',
}
const FiveDigitAddon: Extension = {
  name: 'five_digit_add_on',
  type: 'extension',
  humanReadable: '5 digit Addon',
}

export const symbologiesExtension: Record<'1dRetail' | 'all', Extension[]> = {
  '1dRetail': [TwoDigitAddon, FiveDigitAddon],
  all: [TwoDigitAddon, FiveDigitAddon],
}

const modeSymbologies: Record<ScannerMode | 'oneD' | 'twoD', Symbology[]> = {
  [ScannerMode.ExternalListBuilding]: [],
  [ScannerMode.ExternalSearchAndFind]: [],
  [ScannerMode.LabelScanning]: [],
  '1dRetail': [
    Symbology.GS1DatabarExpanded,
    Symbology.GS1DatabarLimited,
    Symbology.GS1Databar,
    Symbology.EAN8,
    Symbology.UPCE,
    Symbology.EAN13UPCA,
  ],
  '1dIndustrial': [
    Symbology.Codabar,
    Symbology.Code11,
    Symbology.Code128,
    Symbology.Code25,
    Symbology.Code39,
    Symbology.Code93,
    Symbology.InterleavedTwoOfFive,
    Symbology.MSIPlessey,
  ],
  '2dAll': [
    Symbology.Aztec,
    Symbology.DataMatrix,
    Symbology.KIX,
    Symbology.Lapa4SC,
    Symbology.MaxiCode,
    Symbology.MicroPDF417,
    Symbology.MicroQR,
    Symbology.PDF417,
    Symbology.QR,
    Symbology.RoyalMail4state,
    Symbology.USPSIntelligentMail,
    Symbology.DotCode,
  ],
  qr: [Symbology.MicroQR, Symbology.QR],
  dpm: [Symbology.DataMatrix],
  swissQR: [Symbology.QR],
  all: Object.values(Symbology),
  oneD: [
    Symbology.EAN13UPCA,
    Symbology.Code128,
    Symbology.Code32,
    Symbology.EAN8,
    Symbology.UPCE,
    Symbology.MSIPlessey,
    Symbology.Code39,
    Symbology.Codabar,
    Symbology.Code93,
    Symbology.InterleavedTwoOfFive,
    Symbology.GS1Databar,
    Symbology.Code11,
    Symbology.GS1DatabarExpanded,
    Symbology.Code25,
    Symbology.GS1DatabarLimited,
    Symbology.IATATwoOfFive,
    Symbology.MatrixTwoOfFive,
  ],
  twoD: [
    Symbology.QR,
    Symbology.MicroQR,
    Symbology.PDF417,
    Symbology.Aztec,
    Symbology.MaxiCode,
    Symbology.MicroPDF417,
    Symbology.DataMatrix,
    Symbology.DotCode,
    Symbology.RoyalMail4state,
    Symbology.Lapa4SC,
    Symbology.KIX,
    Symbology.USPSIntelligentMail,
  ],
  batch: [Symbology.EAN8, Symbology.EAN13UPCA, Symbology.UPCE, Symbology.Code128, Symbology.Code39],
}

export default modeSymbologies
